// extracted by mini-css-extract-plugin
export var paginationContainer = "_a4-0";